import React from "react";
import ReactPlayer from "react-player";
import { useTranslation } from "react-i18next";

interface VideoComponentProps {
  videoUrl?: string;
  header: string;
  autoplay?: boolean;
}

const VideoComponent = ({ videoUrl, header, autoplay = false }: VideoComponentProps) => {
  const { t } = useTranslation();

  return (
    <div className="card p-2 sm:p-4 mb-3">
      <div className="text-center mb-3">
        <h2 className="text-900 text-xl sm:text-2xl font-semibold m-0">{t(header)}</h2>
      </div>

      <div className="flex justify-content-center">
        <div
          className="flex align-items-center"
          style={{
            width: "100%",
            position: "relative",
            aspectRatio: "16 / 9", // 16:9 oranı
            maxHeight: "80vh", // İsterseniz maksimum yükseklik ekleyebilirsiniz
            overflow: "hidden",
            margin: "0 auto" // Ortalamayı sağlamak için
          }}
        >
          <ReactPlayer
            url={videoUrl}
            controls
            playing={autoplay}
            width="100%"
            height="100%"
            style={{ position: "absolute", top: 0, left: 0 }}
          />
        </div>
      </div>
    </div>
  );
};

export default VideoComponent;
